/**
 * This is the entry point to a webpack bundle that can be loaded via a <script /> tag
 */
import { SignalsPlugin } from "./index";
export { SignalsPlugin }; // in case someone wants to use the umd module directly

// this will almost certainly be executed in the browser, but since this is UMD,
// we are checking just for the sake of being thorough
if (typeof window !== "undefined") {
  (window as any).SignalsPlugin = SignalsPlugin;

  // Call callback to notify waiting code that SignalsPlugin is ready
  // This solves the race condition where script.onload fires before
  // the JavaScript inside has finished executing
  if (typeof (window as any).signalsPluginReady === "function") {
    try {
      (window as any).signalsPluginReady(SignalsPlugin);
    } catch (error) {
      console.error("Error in signalsPluginReady callback:", error);
    }
  }
}
